import { AppDispatch, RootState } from '@src/store/store'
import { authApi } from '@src/api/auth-api'
import { userApi } from '@src/api/user-api'
import {
  logoutAC,
  setBackError, setCardNumber, setCodes,
  setConfirmAction, setConfirmActionCard,
  setConfirmCardCode,
  setConfirmPhone,
  setIsLoading,
  setIsSuccessRecallPassword,
  setIsSuccessRecoveryPassword, setPhoneForSms,
  setRegisterSuccess, setStep,
} from '@src/store/ducks/auth/reducer'
import { selectAuth, selectAuthConfirmPhone, selectCodesPhone } from '@src/store/ducks/auth/selectors'
import { setIsAuth, setIsInitialized } from '@src/store/ducks/app/reducer'

export const logout = (noLogout?: boolean) => async (dispatch: AppDispatch, getState: () => RootState) => {
  const { app } = getState()
  try {
    if (app.isAuth && !noLogout) {
      await authApi.logout()
    }
    dispatch(logoutAC())
    dispatch(setIsInitialized())
  } catch (err) {
    console.error(err)
  }
}
export const login = (phone: string, password: string) => async (dispatch: AppDispatch) => {
  dispatch(setIsLoading(true))
  dispatch(setBackError(null))
  try {
    const result = await authApi.login(phone.replace(/\D+/g, ''), password)
    localStorage.setItem('Authorization', result.accessToken)
    await userApi.profile()
    dispatch(setIsAuth(true))
  } catch (err: any) {
    console.error(err)
    localStorage.removeItem('Authorization')
    dispatch(setIsAuth(false))
    dispatch(
      setBackError(
        err?.response?.data?.message
        || err?.response?.data
        || 'Ошибка авторизации',
      ),
    )
  } finally {
    dispatch(setIsLoading(false))
  }
}
export const registration = (
  phone: string, password: string, isPromotionalGames: boolean,
  code: string, isLoyalty: boolean, isProcessingPersonalData: boolean,
) => async (dispatch: AppDispatch) => {
  dispatch(setIsLoading(true))
  dispatch(setBackError(null))
  try {
    const result = await authApi.register(phone.replace(/\D+/g, ''),
      password, isPromotionalGames, code, isLoyalty, isProcessingPersonalData)
    localStorage.setItem('Authorization', result.accessToken)
    dispatch(setIsAuth(true))
    dispatch(setRegisterSuccess(true))
    dispatch(setConfirmAction(false))
  } catch (err: any) {
    console.error(err)
    if (err?.response?.status) {
      dispatch(setBackError(err?.response?.data))
    }
  } finally {
    dispatch(setIsLoading(false))
  }
}

export const confirmUserActions = (phone: string, password: string) => async (dispatch: AppDispatch) => {
  dispatch(setIsLoading(true))
  dispatch(setBackError(null))
  try {
    await authApi.sendRegCode(phone.replace(/\D+/g, ''), password)
    dispatch(setConfirmAction(true))
  } catch (err: any) {
    if (err?.response?.status) {
      dispatch(setBackError(err?.response?.data))
    }
  } finally {
    dispatch(setIsLoading(false))
  }
}

export const recoveryPasswordFirstStep = (phone: string) => async (dispatch: AppDispatch) => {
  dispatch(setIsLoading(true))
  try {
    await authApi.recallPassword(phone.replace(/\D+/g, ''))
    dispatch(setConfirmAction(true))
    dispatch(setConfirmPhone(phone))
  } catch (err: any) {
    console.error(err)
    if (err?.response?.status) {
      dispatch(setBackError(err?.response?.data))
    }
  } finally {
    dispatch(setIsLoading(false))
  }
}
export const confirmActionsRecoveryPassword = (codes: string) => async (
  dispatch: AppDispatch, getState: () => RootState,
) => {
  dispatch(setIsLoading(true))
  try {
    const confirmPhone = selectAuthConfirmPhone(getState())
    if (confirmPhone) {
      const result = await authApi.confirmRecallPasswordRegCode(codes, confirmPhone.replace(/\D+/g, ''))
      dispatch(setCodes(codes))
      dispatch(setIsSuccessRecallPassword(result))
    }
    dispatch(setConfirmAction(false))
  } catch (err: any) {
    console.error(err)
  } finally {
    dispatch(setIsLoading(false))
  }
}
export const recoveryPasswordSecondStep = (password: string) => async (
  dispatch: AppDispatch, getState: () => RootState,
) => {
  dispatch(setIsLoading(true))
  try {
    const code = selectCodesPhone(getState())
    const confirmPhone = selectAuthConfirmPhone(getState())
    if (confirmPhone) {
      await authApi.recoveryPassword(password, confirmPhone.replace(/\D+/g, ''), code)
      dispatch(setIsSuccessRecoveryPassword(true))
    }
  } catch (err: any) {
    console.error(err)
  } finally {
    dispatch(setIsLoading(false))
  }
}
// Регистрация карты
export const registerCard = (cardNumber: string) => async (dispatch: AppDispatch) => {
  dispatch(setIsLoading(true))
  dispatch(setBackError(null))
  try {
    const result = await authApi.registerCard(cardNumber)
    if (result.needAnketaForm) {
      dispatch(setCardNumber(cardNumber))
      dispatch(setConfirmCardCode(result.needAnketaForm))
      dispatch(setStep(2))
    } else {
      dispatch(setCardNumber(cardNumber))
      dispatch(setConfirmCardCode(result.needSmsCheckForm))
      dispatch(setPhoneForSms(result.phone))
      dispatch(setStep(3))
    }
  } catch (err: any) {
    console.error(err)
    if (err?.response?.status) {
      dispatch(setBackError(err?.response?.data.message || err?.response?.data))
    }
  } finally {
    dispatch(setIsLoading(false))
  }
}
export const checkPhoneSms = (phone: string) => async (dispatch: AppDispatch) => {
  dispatch(setIsLoading(true))
  dispatch(setBackError(null))
  try {
    await authApi.sendRegCodeCard(phone.replace(/\D+/g, ''))
    dispatch(setConfirmActionCard(true))
    dispatch(setStep(3))
    dispatch(setConfirmPhone(phone))
  } catch (err: any) {
    if (err?.response?.status) {
      dispatch(setBackError(err?.response?.data.message || err?.response?.data))
    }
  } finally {
    dispatch(setIsLoading(false))
  }
}
export const confirmUserCardAct = (code: string) => async (dispatch: AppDispatch, getState: () => RootState) => {
  dispatch(setIsLoading(true))
  dispatch(setBackError(null))
  try {
    const confirmPhone = selectAuthConfirmPhone(getState())
    const cardNumber = selectAuth(getState())
    if (confirmPhone || cardNumber.cardNumber) {
      const result = await authApi.confirmRegCode(code, confirmPhone?.replace(/\D+/g, ''), cardNumber.cardNumber)
      if (result.result) {
        dispatch(setStep(4))
      }
      dispatch(setBackError('Не правильный код'))
    }
  } catch (err: any) {
    console.error(err)
    if (err?.response?.status) {
      dispatch(setBackError(err?.response?.data.message || err?.response?.data))
    }
  } finally {
    dispatch(setIsLoading(false))
  }
}
export const finalRegistrationCard = (
  code: string,
  password: string,
  isProcessingPersonalData: boolean,
  isAcknowledgedPersonalDataPolicy: boolean,
  isLoyalty: boolean,
  isPromotionalMail: boolean,
  isPoll: boolean,
  isPromotionalGames: boolean,
  phone: string,
  name: string,
  surname: string,
  patronymic: string,
  // gender: any,
  birthDate: any,
  // email: string,
  // address: string,
  cardNumber:string,
) => async (dispatch: AppDispatch) => {
  dispatch(setIsLoading(true))
  dispatch(setBackError(null))
  try {
    const result = await authApi.finalRegistration(
      code,
      password,
      isProcessingPersonalData,
      isLoyalty,
      isPromotionalMail,
      isPoll,
      isPromotionalGames,
      phone.replace(/\D+/g, ''),
      name,
      surname,
      patronymic,
      // gender,
      birthDate,
      // email,
      // address,
      cardNumber,
    )
    localStorage.setItem('Authorization', result.accessToken)
    dispatch(setIsAuth(true))
    dispatch(setRegisterSuccess(true))
    dispatch(setConfirmActionCard(false))
  } catch (err: any) {
    console.error(err)
    if (err?.response?.status) {
      dispatch(setBackError(err?.response?.data.message || err?.response?.data))
    }
  } finally {
    dispatch(setIsLoading(false))
  }
}
